export default "__VITE_ASSET__BwXjAhbh__"